// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__ryb45","productName":"Table_productName__3w9X4"};